import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Phone } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1500198894528-3819de6ad916?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxDb3JmdSUyMEdyZWVjZXxlbnwwfHx8fDE3Nzk5NzM2OTJ8MA&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/70 via-blue-800/60 to-cyan-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1600px] mx-auto px-6 sm:px-12 py-20 mt-20">
        <div className="max-w-5xl mx-auto text-center">
          {/* Logo */}
          <div className="flex justify-center mb-8 animate-fade-in">
            <img 
              src="https://customer-assets.emergentagent.com/job_corfu-rides/artifacts/y4dhay9n_Diamond-removebg-preview.png"
              alt="Golden Corfu Transfers Logo"
              className="w-64 sm:w-80 md:w-96 h-auto drop-shadow-[0_0_30px_rgba(251,191,36,0.4)]"
            />
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Golden Corfu <span className="text-yellow-300">Transfer</span>
          </h1>

          {/* Slogan */}
          <p className="text-xl sm:text-2xl lg:text-3xl text-white/90 mb-4 font-light">
            Private Transfers Across Corfu
          </p>
          <p className="text-lg sm:text-xl text-cyan-200 mb-8">
            with Comfort & Style
          </p>

          {/* Description */}
          <p className="text-base sm:text-lg text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
            Experience premium transportation services across the beautiful island of Corfu. 
            Professional drivers, luxury vehicles, and unbeatable comfort for all your transfer needs.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              size="lg"
              onClick={scrollToContact}
              className="bg-gradient-to-r from-yellow-500 to-amber-600 hover:from-yellow-600 hover:to-amber-700 text-white font-semibold px-8 py-6 text-lg rounded-full shadow-2xl hover:shadow-yellow-500/50 transition-all duration-300 hover:scale-105"
            >
              Book Your Transfer
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-md border-2 border-white/50 hover:bg-white/20 text-white font-semibold px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105"
              onClick={() => window.location.href = 'tel:+306970339676'}
            >
              <Phone className="mr-2" size={20} />
              Call Now
            </Button>
          </div>

          {/* Features */}
          <div className="grid grid-cols-3 gap-3 sm:gap-6 mt-16 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-3 sm:p-6 hover:bg-white/20 transition-all duration-300">
              <div className="text-xl sm:text-3xl font-bold text-yellow-300 mb-1 sm:mb-2">24/7</div>
              <div className="text-white text-xs sm:text-sm">Available Anytime</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-3 sm:p-6 hover:bg-white/20 transition-all duration-300">
              <div className="text-xl sm:text-3xl font-bold text-yellow-300 mb-1 sm:mb-2">100%</div>
              <div className="text-white text-xs sm:text-sm">Satisfaction</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-3 sm:p-6 hover:bg-white/20 transition-all duration-300">
              <div className="text-xl sm:text-3xl font-bold text-yellow-300 mb-1 sm:mb-2">Fixed</div>
              <div className="text-white text-xs sm:text-sm">Transparent Pricing</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;